document.addEventListener('DOMContentLoaded', function () {
 
  // Toggle dropdown
  document.body.addEventListener('click', function(e) {
 
    const toggle = e.target.closest('[data-disclosure-toggle]');
    if (toggle) {
      e.preventDefault();
 
      const disclosure = toggle.closest('.disclosure');
 
      // close all others
      document.querySelectorAll('.disclosure').forEach(function(item) {
        if (item !== disclosure) {
          item.classList.remove('is-open');
        }
      });
 
      disclosure.classList.toggle('is-open');
    }
 
    // Select option
    const option = e.target.closest('[data-disclosure-option]');
    if (option) {
      e.preventDefault();
 
      const form = option.closest('form');
      const input = form.querySelector('[data-disclosure-input]');
      input.value = option.dataset.value;
 
      form.submit();
    }
 
    // Click outside → close
    if (!e.target.closest('.disclosure')) {
      document.querySelectorAll('.disclosure').forEach(function(item) {
        item.classList.remove('is-open');
      });
    }
 
  });
 
});

// product image zoom on product page
 $('.zoom-desk-icon').click(function(){
             $(this).closest('.product__main-photos').find('.product-main-slide.is-selected .product__photo-zoom').click()
          })

$('.video_wrapper__around').slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1
});

$('.video-text-around').slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1
});


$('.coll__listing').slick({
  dots: false,
  arrows:true,
  infinite: true,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 769,
      settings: {
        slidesToShow: 2,
        infinite: true
      }
    }
  ]
});

$( document ).ready(function() {
  $('.template-product').find('.prod_description button').click();
  $('.template-collection').find('.grid__item--sidebar .collection-sidebar__group--2 button').click(); 
  $('.collection-filter__btn').click(function(){
    $('.collection-filter__item--right ul').toggleClass('hide');
  });
});

//swym wishlist changes
(function () {
  'use strict';
 
  const CUSTOM_PLANNERS = {
 
    'classic-custom-planner-build-your-own': {
      price: 'Starting from $29.99',
      url: '/products/classic-custom-planner-build-your-own'
    },
 
    'big-custom-planner-build-your-own': {
      price: 'Starting from $34.99',
      url: '/products/big-custom-planner-build-your-own'
    },
 
    'mini-custom-planner-build-your-own': {
      price: 'Starting from $23.99',
      url: '/products/mini-custom-planner-build-your-own'
    }
 
  };
 
  //  * Get Shopify product handle
  function getProductHandle(container) {
 
    const productLink = container.querySelector(
      'a.swym-more-details-btn, ' +
      'a.swym-wishlist-image-wrapper'
    );
 
    if (!productLink) return null;
 
    try {
 
      const url = new URL(
        productLink.href,
        window.location.origin
      );
 
      const match = url.pathname.match(/\/products\/([^/]+)/);
      return match ? match[1] : null;
 
    } catch (error) {
      return null;
    }
 
  }
 
  
  //  * Update Wishlist
  function updateWishlist() {
 
    document.querySelectorAll('.swym-wishlist-item').forEach(function (item) {
 
        const handle = getProductHandle(item);
        const product =CUSTOM_PLANNERS[handle];
 
        if (!product) return;
 
        const priceElement =
          item.querySelector(
            '.swym-product-price .swym-product-final-price'
          );
 
        if (priceElement) {
 
          priceElement.classList.add(
            'swym-custom-planner-price'
          );
 
          priceElement.setAttribute(
            'data-custom-planner-price',
            product.price
          );
 
          priceElement.setAttribute(
            'aria-label',
            product.price
          );
 
        }
 
        const button =
          item.querySelector(
            '.swym-add-to-cart-btn'
          );
 
        if (button) {
 
          button.classList.add(
            'swym-custom-planner-button'
          );
 
          button.setAttribute(
            'aria-label',
            'Customize Planner'
          );
 
          button.dataset.customPlanner =
            'true';
 
          button.dataset.customPlannerUrl =
            product.url;
        }
 
      });
 
  }
 
  // Update Wishlist Product Detail / Carousel
  function updateWishlistProductDetail() {
 
    document
      .querySelectorAll(
        '.swym-wishlist-product-detail-content'
      )
      .forEach(function (item) {
 
        const handle =getProductHandle(item);
 
        const product =CUSTOM_PLANNERS[handle];
 
        if (!product) return;

        const priceElement =
          item.querySelector(
            '.swym-product-price .swym-product-final-price'
          );
 
        if (priceElement) {
 
          priceElement.classList.add(
            'swym-custom-planner-price'
          );
 
          priceElement.setAttribute(
            'data-custom-planner-price',
            product.price
          );
 
          priceElement.setAttribute(
            'aria-label',
            product.price
          );
 
        }
 
        const button =
          item.querySelector(
            '.swym-wishlist-add-to-cart-btn'
          );
 
        if (button) {
 
          button.classList.add(
            'swym-custom-planner-button'
          );
 
          button.setAttribute(
            'aria-label',
            'Customize Planner'
          );
 
          button.dataset.customPlanner =
            'true';
 
          button.dataset.customPlannerUrl =
            product.url;
 
        }
 
        // More Details URL
        const detailsLink =
          item.querySelector(
            '.swym-more-details-btn'
          );
 
        if (detailsLink) {
 
          detailsLink.setAttribute(
            'href',
            product.url
          );
 
        }
 
      });
  }
 

  function updateSwymUI() {
    updateWishlist();
    updateWishlistProductDetail();
  }
 

  document.addEventListener(
    'click',
    function (event) {
 
      const button =
        event.target.closest(
          '.swym-add-to-cart-btn, ' +
          '.swym-wishlist-add-to-cart-btn'
        );
 
      if (!button) return;
 
 
      /*
       * Only custom planners
       */
      if (
        button.dataset.customPlanner !==
        'true'
      ) {
        return;
      }
 
 
      const url =
        button.dataset.customPlannerUrl;
 
      if (!url) return;
  
      //  * Stop Swym's Add To Cart
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      
      //  * Go to product page
      window.location.href = url;
 
    },
    true
  );
 
  updateSwymUI();
 
  
  //  * Observe Swym dynamic rendering
  let updateTimeout = null;
 
  const observer =
    new MutationObserver(
      function () {
 
        if (updateTimeout) {
          return;
        }
 
        updateTimeout =
          setTimeout(
            function () {
 
              updateTimeout = null;
 
              updateSwymUI();
 
            },
            200
          );
 
      }
    );
 

  observer.observe(
    document.body,
    {
      childList: true,
      subtree: true
    }
  );
 
})();



 